import gql from 'graphql-tag';

export const QUERY_GET_COUNTRIES = gql`
  query queryGetCountries($pageSize: Int) {
    countries(pageSize: $pageSize) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
`;
